import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      testid="page-privacy"
      title="Privacy Policy"
      intro={
        "This Privacy Policy describes what personal information Shanvi Resources collects, how we use it, and the choices you have. It applies to your use of SERP — Shanvi Enterprise Resource Planning."
      }
      sections={[
        {
          heading: "Information we collect",
          paragraphs: [
            "Account information — your name, email address, company name and role — collected when you register a workspace.",
            "Operational data — the mining plans, cost sheets and reports you create inside SERP. This is stored on our servers so we can serve it back to you.",
            "Usage data — technical logs such as your IP address, browser type, pages visited and timestamps. We use this only to keep the service secure and running.",
          ],
        },
        {
          heading: "How we use the information",
          paragraphs: [
            "To provide, maintain and improve SERP and its features.",
            "To send you transactional emails (invitations, scheduled export digests) via Resend. We do not sell your email address, and we do not send marketing email without your explicit consent.",
            "To respond to your contact-form submissions.",
          ],
        },
        {
          heading: "Sharing",
          paragraphs: [
            "We do not sell your personal information. We only share it with the following categories of processors, and only to the extent necessary to operate the service:",
            "• Cloud hosting: our infrastructure providers (data-centre operators).",
            "• Email dispatch: Resend (email delivery).",
            "• AI processing: Anthropic and Google (large language model providers), for the specific content you send to the AI endpoint at the moment of the request.",
            "All processors are contractually required to protect your information.",
          ],
        },
        {
          heading: "Data retention",
          paragraphs: [
            "We keep your account and workspace data for as long as your account is active. If you delete your account, we delete or anonymise your personal information within 30 days, except where retention is required for legal or regulatory reasons.",
          ],
        },
        {
          heading: "Your rights",
          paragraphs: [
            "You may access, correct, export or delete your personal information at any time by contacting us via the contact form. We will respond within thirty (30) days.",
            "If you are located in the European Economic Area, the United Kingdom, or another jurisdiction with equivalent laws, you may also lodge a complaint with your local data protection authority.",
          ],
        },
        {
          heading: "Security",
          paragraphs: [
            "We take security seriously. Passwords are stored hashed with bcrypt, authentication uses HttpOnly cookies with JWT, and sensitive endpoints are rate-limited. Nonetheless, no system is perfectly secure — you use SERP at your own risk.",
          ],
        },
        {
          heading: "Cookies",
          paragraphs: [
            "SERP uses a single HttpOnly authentication cookie to keep you signed in. We do not use analytics or advertising cookies.",
          ],
        },
        {
          heading: "Changes",
          paragraphs: [
            "We may update this policy from time to time. We will notify you by email of material changes at least thirty (30) days before they take effect.",
          ],
        },
      ]}
    />
  );
}
